import * as THREE from "three";
import LayerMappingsEnum from "../../enums/LayerMappingsEnum";
import ISceneGeometry from "../sceneObject/ISceneGeometry";
import SceneObjectData from "../sceneObjectData/SceneObjectData";
import CompoundSceneGeometry from "./CompoundSceneGeometry";

import { tolerances } from "../../utils/constants";
import TextAnnotationData from "../sceneObjectData/TextAnnotationData";
import TextAnnotationGeometry from "../sceneObject/TextAnnotationGeometry";

export default class TextAnnotationCompoundGeometry extends CompoundSceneGeometry<TextAnnotationData> {

    geometry2d: TextAnnotationGeometry = new TextAnnotationGeometry();
    geometry3d: TextAnnotationGeometry = new TextAnnotationGeometry();
    
    constructor() {
        super();

        this.group.add(this.geometry2d.group);
        this.group.add(this.geometry3d.group);
    }

    protected getSubGeometries() : ISceneGeometry[] {
        return [this.geometry2d, this.geometry3d];
    }

    onAnnotationDirectionChange(rotationOffset: number): void {
        this.geometry2d.onAnnotationDirectionChange(rotationOffset);
        this.geometry3d.onAnnotationDirectionChange(rotationOffset);
    }

    protected updateGeometry(data: SceneObjectData, forceUpdate: boolean): boolean {
        const lengthData = data as TextAnnotationData;
        const result = super.updateGeometry(lengthData, forceUpdate);

        this.geometry2d.setLayer(LayerMappingsEnum.Annotations2d);
        this.geometry3d.setLayer(LayerMappingsEnum.Annotations3d);
        
        // Show 2d geometry only if needed
        if ( this.isVisibleIn2d(lengthData)) { this.geometry2d.show(); }
        else { this.geometry2d.hide(); }

        return result;
    }

    private isVisibleIn2d(data: TextAnnotationData) : boolean {
        if (data.offset.lengthSq() < tolerances.position) 
            return true;

        const diff = 1 - Math.abs(new THREE.Vector3(0,0,1).dot(data.textNormal));
        return  diff < tolerances.directionAngle; // More than 45 degrees to Z axis
    }
};
